import client from '../config/AxiosConfig';

export const GetWeddingContractDeclarationTemplateParams = async (reserveId, language) =>
  client.get(`/weddingContractDeclarationTemplate/params/${reserveId}?language=${language || 'pt'}`);

export const SaveWeddingContractDeclaration = async (reserveId, data) =>
  client.post(`/my-wedding/contractDeclaration/${reserveId}`, data);
